import tw, { styled } from 'twin.macro';

export const StyledFooter = styled.footer<{ sticky: boolean }>`
	${tw`flex justify-end p-4`}
	${({ sticky }) => sticky && tw`sticky bottom-0`}
`;
